import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import classNames from 'classnames'
import { GripVertical, PencilLine, Trash } from 'lucide-react'
import { QuestionCard } from '../question-card'
import { QuestionPreview } from '../question-preview'
import type { QuestionRowProps } from './question-row.interface'
import classes from './question-row.module.scss'

export function QuestionRow({ question, isEditing, onEdit, onDelete, onUpdate, onCancelEdit }: QuestionRowProps) {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
    id: question.key,
    disabled: isEditing,
  })
  const isChoiceList = question.type === 'multiple_choice' || question.type === 'checkboxes'

  return (
    <li
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      className={classNames(classes.root, { [classes.dragging]: isDragging })}
      data-question-key={question.key}
    >
      {isEditing ? (
        <QuestionCard
          mode="edit"
          question={question}
          idPrefix={question.key}
          onConfirm={onUpdate}
          onCancel={onCancelEdit}
          onDelete={onDelete}
        />
      ) : (
        <div className={classes.row}>
          <QuestionPreview question={question} />
          <div className={classNames(classes.actions, { [classes.actionsTop]: isChoiceList })}>
            <button
              type="button"
              ref={setActivatorNodeRef}
              className={classNames(classes.action, classes.handle)}
              {...attributes}
              {...listeners}
              aria-label={`Reorder ${question.label}`}
            >
              <GripVertical size={16} aria-hidden="true" />
            </button>
            <button type="button" className={classes.action} aria-label={`Edit ${question.label}`} onClick={onEdit}>
              <PencilLine size={16} aria-hidden="true" />
            </button>
            <button type="button" className={classes.action} aria-label={`Delete ${question.label}`} onClick={onDelete}>
              <Trash size={16} aria-hidden="true" />
            </button>
          </div>
        </div>
      )}
    </li>
  )
}
